/**
 * @name paIframeParent
 * @version 1.0
 * @author George Yakushenkov
 * @copyright Copyright 2017 Peak Ace AG. All Rights Reserved.
 */

/**
 * Makes connection with {@link paIframeChild} in order to trigger child functions or to be triggered by child messages
 * (f.e. changing width of iframe container when iframe content is loaded)
 *
 * Embedding:
 * <script id="pa-lib-script" data-id="cm-project-78" data-iframe="true" src="assets/js/paIframeParent.js"></script>
 *
 * Workflow:
 * - paIframeParent creates iframe container
 * - paIframeChild initial load
 * - paIframeChild sends message 'childloaded' to paIframeParent
 * - paIframeChild runs application
 * - paIframeChild send new height and disables loading after application is loaded
 */
/**
 * @name paIframeParent
 * @version 1.0
 * @author George Yakushenkov
 * @copyright Copyright 2017 Peak Ace AG. All Rights Reserved.
 */

/**
 * Makes connection with {@link paIframeChild} in order to trigger child functions or to be triggered by child messages
 * (f.e. changing width of iframe container when iframe content is loaded)
 *
 * Embedding:
 * <script id="pa-lib-script" data-id="cm-project-78" data-iframe="true" src="assets/js/paIframeParent.js"></script>
 *
 * Workflow:
 * - paIframeParent creates iframe container
 * - paIframeChild initial load
 * - paIframeChild sends message 'childloaded' to paIframeParent
 * - paIframeChild runs application
 * - paIframeChild send new height and disables loading after application is loaded
 */
export const paIframeParent = {
    // public
    browserCache: true, // for debug
    loadingIndication: true,
    autoDisableIndication: null, // if null - do not autodisable
    waitForDom: true, // if script embeded in HEAD we have to wait for DOMready
    dataset: null,

    route: {hash: null},
    //private
    libSource: '',
    libDomHandler: null,
    dom: {},
    toLoad: [],
    init() {
        // if (!this.isBrowser()) {
        //     this.showBrowserUpdate();
        //     return;
        // }
        this.initRoute();
        if (this.waitForDom && document.readyState === 'loading') {
            if (document.currentScript) {
                this.currentScriptTag = document.currentScript;
            }
            document.addEventListener('DOMContentLoaded', function () {
                this.defines();
                this.initApp();
            }.bind(this));
        } else {
            this.defines();
            this.initApp();
        }

    },
    /**
     * checks if browser can detect script tag in which that script was called from
     * @return {boolean}
     */
    isBrowser() {
        return typeof document.currentScript !== 'undefined';
    },
    /**
     * checks if user has ie 9 or lower
     * @return {Number|boolean}
     */
    isIE9Nightmare() {
        var sAgent = window.navigator.userAgent,
            isIE = sAgent.indexOf('MSIE'),
            version = parseInt(sAgent.substring(isIE + 5, sAgent.indexOf('.', isIE)));
        return isIE && version <= 9;
    },
    /**
     * define user env and vars
     */
    defines() {
        if (!this.iframe) window.paLib = this;
        if (this.isIE9Nightmare()) {
            this.loadingIndication = false;
        }

        /**
         * define current script tag
         */
        if (!this.currentScriptTag) {
            if (document.currentScript) {
                this.currentScriptTag = document.currentScript;
            } else {
                this.currentScriptTag = document.getElementById('pa-lib-script');
            }
        }

        var scriptSrc = this.currentScriptTag.src;
        if (scriptSrc.indexOf('?') > 0) {
            scriptSrc = scriptSrc.substr(0, scriptSrc.indexOf('?'))
        }
        this.libSource = scriptSrc.substr(0, scriptSrc.indexOf('paEngineIframeLoader.js'));

        if (this.currentScriptTag.dataset) {
            this.libDomHandlerId = this.currentScriptTag.dataset.id || 'pa-engine-dom-wrapper';
            this.dataset = this.currentScriptTag.dataset;
        } else {
            this.libDomHandlerId = 'pa-engine-dom-wrapper';
        }

        this.libDomHandler = '#' + this.libDomHandlerId;
        this.createHandler();
        this.dom.handler = document.getElementById(this.libDomHandlerId);

        if (this.dom.handler.dataset) {
            this.lang = typeof this.dom.handler.dataset.lang != 'undefined' ? this.dom.handler.dataset.lang : 'en';
            this.iframe = (this.dom.handler.dataset.iframe == 'false');
        } else {
            this.lang = 'en';
            this.iframe = true;
        }

    },
    /**
     * show warning that browser has to be updated to work properly
     */
    showBrowserUpdate() {
        this.currentScriptTag = document.getElementById('pa-lib-script');
        var div = document.createElement('div');
        div.innerHTML = '<div class="alert" style="position: absolute; z-index: 100000; left: 50%;transform: translate(-50%, 0); top: 0;  background: #fff; margin: 0 auto;  padding: 20px; border: 1px solid #000;">Your browser is out-of-date. <a href="http://browser-update.org/update.html">More Info</a></div>';
        this.currentScriptTag.parentNode.insertBefore(div, this.currentScriptTag);
    },
    /**
     * create container for iframe
     */
    createHandler() {
        if (document.getElementById(this.libDomHandlerId)) return;
        var div = document.createElement('div');
        div.style.position = 'relative';
        div.style.width = '100%';
        div.id = this.libDomHandler.substr(1);
        if (this.loadingIndication) div.innerHTML = this.getLoading();
        this.currentScriptTag.parentNode.insertBefore(div, this.currentScriptTag);
    },
    /**
     * parse current route
     */
    initRoute() {
        this.route.hash = window.location.hash.substring(1);
        if (window.location.href.indexOf('#') > -1) {
            this.route.base = window.location.href.substr(0, window.location.href.indexOf('#'));
        } else {
            this.route.base = window.location.href;
        }
    },
    /**
     * start app with appropriate method
     */
    initApp() {
        this.initListener(this.libDomHandlerId);
        this.initAppIframeMethod();
    },
    /**
     * adds iframe message event listener which triggers methods in child class if parent says so
     */
    initListener(id) {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
            messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message';
        window[eventMethod](messageEvent, function (e) {
            var data = e[e.message ? 'message' : 'data'];
            // check if this iframe belongs to this lib
            var slashEnd = paIframeParent.libSource.substring(8).search('/'),
                libOrigin = paIframeParent.libSource.substring(0, slashEnd + 8),
                sameOrigin = libOrigin == e.origin,
                sameId = id == e.data.id;

            if (!sameOrigin) {
                // console.log('origin conflict');
                return;
            }

            if (sameId && data.task) {
                if (data.task) {
                    if (paLib[data.task]) {
                        paLib[data.task].call(paLib, data);
                    } else {
                        console.log('there is no such method as ' + data.task);
                    }
                }
            }
        }, false);
    },
    /**
     * start app with iframe method
     */
    initAppIframeMethod() {
        paIframeParent.openIframe();
    },
    /**
     * replace routes in parsed css
     * @param data
     * @param exp
     * @param targetFolder
     * @return {void|XML|*|string}
     */
    fixRoutes(data, exp, targetFolder) {
        targetFolder = targetFolder || 'img';
        exp = exp || /\.\.\/img\//ig;
        return data.replace(exp, this.libSource + targetFolder + '/');
    },
    /**
     * wrap asset url with cache string
     * @param src
     * @param remote
     * @return {string}
     */
    wrapSrc(src, remote) {
        remote = remote || false;

        var withCache = this.browserCache ? src : src + '?rnd=' + Math.floor((Math.random() * 9999) + 1000);
        return withCache.substr(0, 4) == 'http' && remote ? withCache : this.libSource + withCache;
    },
    /**
     * create iframe element
     */
    openIframe() {
        var iframe = document.createElement('IFRAME');

        if (!this.dataset.id) {
            console.log('Error: no data id property');
            return;
        }
        var url = this.libSource + 'index.html?id=' + this.libDomHandlerId;
        if (typeof this.route.hash != 'undefined' && this.route.hash) {
            url += '#' + this.route.hash
        }
        iframe.setAttribute('src', url);
        iframe.setAttribute('frameborder', 0);
        iframe.style.width = '100%';
        iframe.style.height = '802px';

        iframe.style['margin-bottom'] = '0';
        iframe.style.overflow = 'hidden';
        document.getElementById(this.libDomHandlerId).appendChild(iframe);
        this.iframe = (iframe.contentWindow || iframe.contentDocument);
    },
    /**
     * action that fires when child iframe is loaded
     */
    childLoaded() {
        var iframeHeight = document.querySelector(this.libDomHandler).offsetHeight,
            iframeWidth = document.querySelector(this.libDomHandler).offsetWidth;
        this.iframe.postMessage({
            task: 'data',
            data: paIframeParent.data,
            libSource: paIframeParent.libSource,
            libDomHandler: paIframeParent.libDomHandler,
            iframeHeight: iframeHeight,
            iframeWidth: iframeWidth
        }, '*');
    },
    /**
     * action than fires when child sends its height
     * @param data
     */
    changeHeight(data) {
        document.querySelector('#' + data.id + ' > iframe').style.height = data.height + 'px';
    },
    /**
     * create loading indicator
     * @return {string}
     */
    getLoading() {
        var css = '<style type="text/css">.pa-loading{position:absolute;z-index:999;height:100%;width:100%;overflow:visible;margin:auto;top:0;left:0;bottom:0;right:0;padding:20px;margin-left:-20px;background-color:rgba(255,255,255,0.8);border-radius:4px}.pa-loading:before{content:\'\';display:block;position:fixed;top:0;left:0;width:100%;height:100%}.pa-loading:not(:required){font:0/0 a;color:transparent;text-shadow:none;border:0}.pa-loading:not(:required):after{content:\'\';display:block;font-size:10px;width:1em;height:1em;margin-top:-.5em;-webkit-animation:spinner 1500ms infinite linear;-moz-animation:spinner 1500ms infinite linear;-ms-animation:spinner 1500ms infinite linear;-o-animation:spinner 1500ms infinite linear;animation:spinner 1500ms infinite linear;border-radius:.5em;box-shadow:#033069 1.5em 0 0 0,#033069 1.1em 1.1em 0 0,#033069 0 1.5em 0 0,#033069 -1.1em 1.1em 0 0,#033069 -1.5em 0 0 0,#033069 -1.1em -1.1em 0 0,#033069 0 -1.5em 0 0,#033069 1.1em -1.1em 0 0;left:50%;position:absolute;top:150px}@-webkit-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}100%{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}</style>';
        return css + '<div id="pa-loading-' + paIframeParent.libDomHandlerId + '" class="pa-loading">Loading&#8230;</div>';
    },
    /**
     * remove loading indicator
     * @param timeout
     */
    disableLoading(timeout) {
        timeout = timeout || 0;
        setTimeout(function () {
            if (typeof timeout === 'object') {
                paIframeParent.removeDOMElement('pa-loading-' + timeout.id);
            } else {
                paIframeParent.removeDOMElement('pa-loading-' + paIframeParent.libDomHandlerId);
            }
        }, timeout);
    },
    /**
     * remove element from DOM
     * @param id
     */
    removeDOMElement(id) {
        if (document.getElementById(id)) {
            var elem;
            (elem = document.getElementById(id)).parentNode.removeChild(elem)
        }
    }
};
paIframeParent.init();


// WEBPACK FOOTER //
// ./src/js/framework/paIframeParent.js